<template>
    <div class="full-height">
      <crud-layout
        ref="crudLayout"
        :name="name"
        :interface="interface"
        :id="id"
        :page="page"
        :pageDetail="pageDetail"
      />
    </div>
  </template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { repository } from 'jtech'
import RepresentativePage from './RepresentativePage.vue'
import RepresentativeDetailPage from './RepresentativeDetailPage.vue'

const CrudLayout = JtCrud.CrudLayout

  @Component({
    name: 'Representative',
    components: { CrudLayout, RepresentativePage, RepresentativeDetailPage },
    props: {
      id: String,
      interface: String,
      name: String
    }
  })
class Representative extends Vue {
    get page () {
      return RepresentativePage
    }

    get pageDetail () {
      return RepresentativeDetailPage
    }

    async btAlterar ({ button, params, page, controller }) {
      const id = params.id
      await repository.update(button.action, { ...params, id: id })
      this.$refs.crudLayout.removePage(page)
    }

    async btGravar ({ button, params, page, controller }) {
      await repository.create(button.action, params)
      page.limparForm()
    }

    mounted () {
      try {
        this.$refs.crudLayout.onButton('btAlterar', this.btAlterar)
        this.$refs.crudLayout.onButton('btGravar', this.btGravar)
      } catch (error) {
        console.error(error)
      }
    }
  }

export default Representative
</script>
  <style lang="stylus" scoped></style>
